module.exports = __webpack_public_path__ + "media/images/dashboard/adwords_logo-0e672130d839051d673061b6be1d49dd.png";